// equal-validator.directive.ts
import { Attribute } from '@angular/core';
var EqualValidator = /** @class */ (function () {
    function EqualValidator(validateEqual, reverse) {
        this.validateEqual = validateEqual;
        this.reverse = reverse;
    }
    Object.defineProperty(EqualValidator.prototype, "isReverse", {
        get: function () {
            if (!this.reverse)
                return false;
            return this.reverse === 'true' ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    EqualValidator.prototype.validate = function (c) {
        // self value
        var v = c.value;
        // control vlaue
        var e = c.root.get(this.validateEqual);
        // value not equal
        if (e && v !== e.value && !this.isReverse) {
            return {
                validateEqual: false
            };
        }
        // value equal and reverse
        if (e && v === e.value && this.isReverse) {
            delete e.errors['validateEqual'];
            if (!Object.keys(e.errors).length)
                e.setErrors(null);
        }
        // value not equal and reverse
        if (e && v !== e.value && this.isReverse) {
            e.setErrors({ validateEqual: false });
        }
        return null;
    };
    EqualValidator.ctorParameters = function () { return [{ type: null, decorators: [{ type: Attribute, args: ['validateEqual'] }] }, { type: null, decorators: [{ type: Attribute, args: ['reverse'] }] }]; };
    return EqualValidator;
}());
export { EqualValidator };
//# sourceMappingURL=equal-validator.directive.js.map


// WEBPACK FOOTER //
// equal-validator.directive.js